import React, {FC, useEffect, useRef, useState} from "react";
import {Carousel} from "react-responsive-carousel";
import { BlogsData } from "../types";
import { getBlogsLists } from "../../service";
import { VideoItem } from './videoItem'




function VideoList() {

    const [lists,setLists] = useState<Array<BlogsData>>([])
    const [active,setActive] = useState(0)
    const [more,setMore] = useState(true)
    const [pageNum,setPage] = useState<number>(1)
    const slick = useRef(null)

    useEffect(() => {
        getBlogsLists({
            pageNum
        }).then(res => {
            if(res.code === 1){
                const l = (res.data.list as Array<BlogsData>)
                if(l.length > 0){
                    setLists(list => list.concat(res.data.list))
                }else{
                    setMore(false)
                }

            }
            // console.log(slick)
        })
    },[pageNum])

    useEffect(() => {
       if(slick !== null){
           // @ts-ignore
           slick.current.updateSizes()
       }

    },[lists])

    const swipeChange = (e:number) => {
        setTimeout(() => {
            setActive(e)
            if(e + 1 >= lists.length && more){
                setPage(page => page + 1)
            }
        },100)
    }

    const options = {
        showThumbs:false,
        showArrows:false,
        showStatus:false,
        autoPlay:false,
        infiniteLoop:false,
        showIndicators:false,
        dynamicHeight:true
    }

    // console.log(active)

    return <div className="video-lists">
        <Carousel ref={ slick } {...options} axis={'vertical'} transitionTime={350} onChange={swipeChange}>
            {
                lists.map((item,index) => {
                    return <VideoItem {...item} isActive={ active === index } key={ index }/>
                })
            }
        </Carousel>
    </div>
}

function Vlog() {

    const [tip,setTip] = useState(true)

    return <div className="vlog-page">
        <VideoList/>
        {
            tip && <div className="tip" onClick={() => setTip(false) }>
                <p className="iconfont">&#xe614;</p>
                <div>滑动查看更多</div>
            </div>
        }

    </div>
}

export default Vlog;
